/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner } from './get-slack-evidence-reminder200-response-inner-user-accounts-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissue } from './get-slack-evidence-reminder200-response-inner-user-accounts-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser } from './get-slack-evidence-reminder200-response-inner-user-accounts-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup } from './get-slack-evidence-reminder200-response-inner-user-accounts-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'user': GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissue}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'reissue'?: GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissue | null;
}

export const GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];


